// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/DBDreamB.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/DBGothicB.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/DBGothicL.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/DBGothicM.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/font/EungeulipParkDahyun.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/font/ongleip_konkon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/font/MemomentKkukkukk/MemomentKkukkukk.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../public/font/Paperlogy/Paperlogy-4Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'DBDreamB'; /* 원하는 폰트 이름 지정 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'); /* TTF 형식 */
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'DBGothicB'; /* 원하는 폰트 이름 지정 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype'); /* TTF 형식 */
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'DBGothicL'; /* 원하는 폰트 이름 지정 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'); /* TTF 형식 */
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'DBGothicM'; /* 원하는 폰트 이름 지정 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'); /* TTF 형식 */
  font-weight: normal;
  font-style: normal;
}

/* 추가 폰트 */
@font-face {
  font-family: 'EungeulipParkDahyun';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'ongleip_konkon';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'MemomentKkukkukk';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Paperlogy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

/* @font-face {
  font-family: 'PyeongChangPeace';
  src: url('../../public/font/PyeongChangPeace/PyeongChangPeace-Bold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
} */

/* Container & Layout */
.card-news-container {
  padding: 5px;
  width: 90%;
  height: auto;
  max-height: 820px;
  background-color: #e0e0e0;
  border-radius: 10px;
}

.card-news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 100%));
  gap: 20px;
  margin-top: 20px;
}

.card-news-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Card Structure */
.card-news-item {
  border: none; /* 테두리 제거 */
  border-radius: 20px; /* 둥근 모서리 증가 */
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 그림자 효과 강화 */
}

.card-news-content {
  background-color : white;
  aspect-ratio: 9/16;
  padding: 10px 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 680px;
  /* max-width: 80%; */
  max-width: 20rem;
  border-radius: 15px;
  margin: 0 auto;
}

/* Text Content */
.card-title-db {
  font-size: 32px;
  font-weight: bold;
  color: #008275;
  text-align: center;
  word-break: keep-all;
  line-height: 1.4;
  margin: 20px 0 10px;
  font-family: 'DBDreamB';
}

.card-subtitle-db {
  font-size: 24px;
  color: #000;
  text-align: center;
  margin-bottom: 0px;
  font-family: 'DBDreamB';
}

.card-description-db-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  /* margin: 20px 0; */
}

.card-description-db {
  width: 85%;
  max-width: 340px;
  font-size: 18px;
  color: #333;
  line-height: 1.8;
  word-break: keep-all;
  white-space: pre-line;
  text-align: center;
  letter-spacing: 0px;
  font-weight: bolder;
  text-wrap: pretty;
  text-wrap-style: balance;
  margin: 0;
  /* 표시되는 줄수 제한 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4; /* 제한할 줄 수 */
  overflow: hidden;
  /* text-overflow : ellipsis; */
}
/* 
.card-description-db::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background-image: url('https://persona-content-gen.o2o.kr/img/exclamation.png');
  background-size: cover;
  background-position: center;
} */

.image-overflow {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
}

.image-overflow img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}


/* 물음표나 느낌표 뒤에서 줄바꿈 */
.card-description-db::after {
  content: '';
  white-space: pre-wrap;
}

/* Image Section */
.card-image-db {
  width: 85%;
  padding: 20px;
  margin: 0 auto;
  display: table;
}

.generated-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  /* border-radius: 15px; */
  border-radius: 150px;
  /* border: 2px groove #008276; */
}

.card-footer-db {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  padding: 0 20px;
}

.company-logo-db {
  position: absolute;
  bottom: 40px;
  left: 44%;
  transform: translateX(-50%);
  width: 120px;
  height: 30px;
  object-fit: contain;
  /* 이미지 캐싱 및 깜빡임 방지 */
  content-visibility: auto;
  will-change: contents;
}

.approval-number {
  position: absolute;
  bottom: 0;
  left: 20px;
  font-size: 14px;
  color: #666;
}

/* Download Buttons */
.card-news-controls {
  margin-bottom: 20px;
  text-align: center;
}

.download-all-button {
  background-color: #008275; /* DB손보 브랜드 컬러 */
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease;
}

.download-all-button:hover {
  background-color: #006c61;
  transform: translateY(-2px);
}

.download-button {
  padding: 10px 22px;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
  line-height: 1;
  max-height: 32px;
  width: 75px;
}

.download-button:hover {
  background-color: #e0e0e0;
  transform: translateY(-2px);
}

/* Disabled States */
.download-button:disabled,
.download-all-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* 텍스트 래핑 유틸리티 */
.text-wrap {
  white-space: pre-line;
  word-break: keep-all;
  overflow-wrap: break-word;
}

/* 대시보드 버튼 스타일 */
.dashboard-button {
  position: relative;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  color: white;
  background-color: #6cc06c; /* 버튼 배경색 */
  border: none;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease;
  cursor: pointer;
  float: right;
}

.dashboard-button:hover {
  background-color: #008000; /* 호버 효과 */
}

.text-overflow-indicator {
  color: red;
  /* font-size: 14px; */
  text-align: center;
  /* margin-top: 5px; */
  margin-left: 5px;
  font-weight: bold;
  float: left;
}`, "",{"version":3,"sources":["webpack://./src/css/cardnews.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB,EAAE,iBAAiB;EAC1C,+DAA2D,EAAE,WAAW;EACxE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB,EAAE,iBAAiB;EAC3C,+DAA4D,EAAE,WAAW;EACzE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB,EAAE,iBAAiB;EAC3C,+DAA4D,EAAE,WAAW;EACzE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB,EAAE,iBAAiB;EAC3C,+DAA4D,EAAE,WAAW;EACzE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,kCAAkC;EAClC,+DAAwE;EACxE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAAmE;EACnE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,+DAAsF;EACtF,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAiF;EACjF,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;;GAMG;;AAEH,uBAAuB;AACvB;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,YAAY,EAAE,WAAW;EACzB,mBAAmB,EAAE,cAAc;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC,EAAE,cAAc;AAC3D;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB,EAAE,YAAY;EACnC,gBAAgB;EAChB,8BAA8B;AAChC;AACA;;;;;;;;;;;GAWG;;AAEH;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;;AAGA,qBAAqB;AACrB;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB,EAAE,WAAW;EACtC,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;EACtC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,UAAU;AACvC;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb","sourcesContent":["@font-face {\n  font-family: 'DBDreamB'; /* 원하는 폰트 이름 지정 */\n  src: url('../assets/fonts/DBDreamB.ttf') format('truetype'); /* TTF 형식 */\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'DBGothicB'; /* 원하는 폰트 이름 지정 */\n  src: url('../assets/fonts/DBGothicB.ttf') format('truetype'); /* TTF 형식 */\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'DBGothicL'; /* 원하는 폰트 이름 지정 */\n  src: url('../assets/fonts/DBGothicL.ttf') format('truetype'); /* TTF 형식 */\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'DBGothicM'; /* 원하는 폰트 이름 지정 */\n  src: url('../assets/fonts/DBGothicM.ttf') format('truetype'); /* TTF 형식 */\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* 추가 폰트 */\n@font-face {\n  font-family: 'EungeulipParkDahyun';\n  src: url('../../public/font/EungeulipParkDahyun.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'ongleip_konkon';\n  src: url('../../public/font/ongleip_konkon.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'MemomentKkukkukk';\n  src: url('../../public/font/MemomentKkukkukk/MemomentKkukkukk.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Paperlogy';\n  src: url('../../public/font/Paperlogy/Paperlogy-4Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* @font-face {\n  font-family: 'PyeongChangPeace';\n  src: url('../../public/font/PyeongChangPeace/PyeongChangPeace-Bold.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n} */\n\n/* Container & Layout */\n.card-news-container {\n  padding: 5px;\n  width: 90%;\n  height: auto;\n  max-height: 820px;\n  background-color: #e0e0e0;\n  border-radius: 10px;\n}\n\n.card-news-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 100%));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.card-news-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* Card Structure */\n.card-news-item {\n  border: none; /* 테두리 제거 */\n  border-radius: 20px; /* 둥근 모서리 증가 */\n  overflow: hidden;\n  background: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 그림자 효과 강화 */\n}\n\n.card-news-content {\n  background-color : white;\n  aspect-ratio: 9/16;\n  padding: 10px 5px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  height: 680px;\n  /* max-width: 80%; */\n  max-width: 20rem;\n  border-radius: 15px;\n  margin: 0 auto;\n}\n\n/* Text Content */\n.card-title-db {\n  font-size: 32px;\n  font-weight: bold;\n  color: #008275;\n  text-align: center;\n  word-break: keep-all;\n  line-height: 1.4;\n  margin: 20px 0 10px;\n  font-family: 'DBDreamB';\n}\n\n.card-subtitle-db {\n  font-size: 24px;\n  color: #000;\n  text-align: center;\n  margin-bottom: 0px;\n  font-family: 'DBDreamB';\n}\n\n.card-description-db-wrap {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  /* margin: 20px 0; */\n}\n\n.card-description-db {\n  width: 85%;\n  max-width: 340px;\n  font-size: 18px;\n  color: #333;\n  line-height: 1.8;\n  word-break: keep-all;\n  white-space: pre-line;\n  text-align: center;\n  letter-spacing: 0px;\n  font-weight: bolder;\n  text-wrap: pretty;\n  text-wrap-style: balance;\n  margin: 0;\n  /* 표시되는 줄수 제한 */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 4; /* 제한할 줄 수 */\n  overflow: hidden;\n  /* text-overflow : ellipsis; */\n}\n/* \n.card-description-db::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 20px;\n  height: 20px;\n  background-image: url('https://persona-content-gen.o2o.kr/img/exclamation.png');\n  background-size: cover;\n  background-position: center;\n} */\n\n.image-overflow {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 20px;\n  height: 20px;\n}\n\n.image-overflow img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n\n/* 물음표나 느낌표 뒤에서 줄바꿈 */\n.card-description-db::after {\n  content: '';\n  white-space: pre-wrap;\n}\n\n/* Image Section */\n.card-image-db {\n  width: 85%;\n  padding: 20px;\n  margin: 0 auto;\n  display: table;\n}\n\n.generated-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  /* border-radius: 15px; */\n  border-radius: 150px;\n  /* border: 2px groove #008276; */\n}\n\n.card-footer-db {\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  width: 100%;\n  padding: 0 20px;\n}\n\n.company-logo-db {\n  position: absolute;\n  bottom: 40px;\n  left: 44%;\n  transform: translateX(-50%);\n  width: 120px;\n  height: 30px;\n  object-fit: contain;\n  /* 이미지 캐싱 및 깜빡임 방지 */\n  content-visibility: auto;\n  will-change: contents;\n}\n\n.approval-number {\n  position: absolute;\n  bottom: 0;\n  left: 20px;\n  font-size: 14px;\n  color: #666;\n}\n\n/* Download Buttons */\n.card-news-controls {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.download-all-button {\n  background-color: #008275; /* DB손보 브랜드 컬러 */\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  transition: all 0.3s ease;\n}\n\n.download-all-button:hover {\n  background-color: #006c61;\n  transform: translateY(-2px);\n}\n\n.download-button {\n  padding: 10px 22px;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background-color 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  white-space: nowrap;\n  line-height: 1;\n  max-height: 32px;\n  width: 75px;\n}\n\n.download-button:hover {\n  background-color: #e0e0e0;\n  transform: translateY(-2px);\n}\n\n/* Disabled States */\n.download-button:disabled,\n.download-all-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* 텍스트 래핑 유틸리티 */\n.text-wrap {\n  white-space: pre-line;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n}\n\n/* 대시보드 버튼 스타일 */\n.dashboard-button {\n  position: relative;\n  padding: 10px 20px;\n  font-size: 1rem;\n  font-weight: bold;\n  color: white;\n  background-color: #6cc06c; /* 버튼 배경색 */\n  border: none;\n  border-radius: 5px;\n  text-decoration: none;\n  transition: background-color 0.3s ease;\n  cursor: pointer;\n  float: right;\n}\n\n.dashboard-button:hover {\n  background-color: #008000; /* 호버 효과 */\n}\n\n.text-overflow-indicator {\n  color: red;\n  /* font-size: 14px; */\n  text-align: center;\n  /* margin-top: 5px; */\n  margin-left: 5px;\n  font-weight: bold;\n  float: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
